// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"867be39c","206":"11d865fe","643":"ee0c4607","694":"5f355c4e","695":"3c43810e","779":"e48f842c","787":"f4d8bbf2","819":"7fc841e1","841":"2b5e88a3"}[chunkId] + ".chunk.js";
};